/* ==========================================================================
   VELIORA — Product page: variants, gallery, sticky ATC, quick view
   ========================================================================== */
(function () {
  'use strict';

  function moneyFormat(cents) {
    const value = (cents / 100).toFixed(2);
    return (window.Veliora && window.Veliora.moneyFormat) ? window.Veliora.moneyFormat.replace('{{amount}}', value) : '$' + value;
  }

  /* ---------- Variant picker ---------- */
  function initVariantPickers(root) {
    (root || document).querySelectorAll('[data-product-info]').forEach((wrap) => {
      if (wrap.dataset.initialized) return;
      wrap.dataset.initialized = 'true';
      let variants = [];
      try {
        variants = JSON.parse(wrap.querySelector('[data-product-variants-json]').textContent);
      } catch (err) {
        return;
      }

      function currentSelection() {
        const selected = [];
        wrap.querySelectorAll('[data-option-index]').forEach((group) => {
          const idx = parseInt(group.getAttribute('data-option-index'), 10);
          const active = group.querySelector('.is-selected, [data-option-value]:checked');
          let value;
          if (group.tagName === 'SELECT') value = group.value;
          else if (active) value = active.getAttribute('data-option-value');
          selected[idx] = value;
        });
        return selected;
      }

      function findVariant() {
        const selection = currentSelection();
        return variants.find((v) => v.options.every((opt, i) => opt === selection[i]));
      }

      function updateUI(variant) {
        const priceEl = wrap.querySelector('[data-product-price]');
        const compareEl = wrap.querySelector('[data-product-compare-price]');
        const addBtn = wrap.querySelector('[data-add-to-cart-btn]');
        const skuEl = wrap.querySelector('[data-product-sku]');
        const idInput = wrap.querySelector('input[name="id"]');
        const form = wrap.querySelector('form[data-product-form]');

        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addBtn.querySelector('.btn-label').textContent = addBtn.dataset.unavailableText || 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = moneyFormat(variant.price);
        if (compareEl) {
          if (variant.compare_at_price > variant.price) {
            compareEl.textContent = moneyFormat(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (skuEl) skuEl.textContent = variant.sku || '';
        if (addBtn) {
          const label = addBtn.querySelector('.btn-label');
          if (variant.available) {
            addBtn.disabled = false;
            label.textContent = addBtn.dataset.addText || 'Add to Bag';
          } else {
            addBtn.disabled = true;
            label.textContent = addBtn.dataset.soldOutText || 'Sold Out';
          }
        }
        if (variant.featured_image) {
          const mainImg = document.querySelector(`[data-product-gallery] [data-media-id="${variant.featured_image.id}"]`);
          if (mainImg) mainImg.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
        if (form && history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
        wrap.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant } }));
      }

      wrap.addEventListener('click', (e) => {
        const pill = e.target.closest('[data-option-value]');
        if (!pill || !wrap.contains(pill)) return;
        const group = pill.closest('[data-option-index]');
        group.querySelectorAll('[data-option-value]').forEach((p) => p.classList.remove('is-selected'));
        pill.classList.add('is-selected');
        const labelValue = group.querySelector('.selected-value');
        if (labelValue) labelValue.textContent = pill.getAttribute('data-option-value');
        updateUI(findVariant());
      });
      wrap.addEventListener('change', (e) => {
        if (e.target.matches('select[data-option-index]')) updateUI(findVariant());
      });

      updateUI(findVariant());
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      const thumbs = gallery.querySelectorAll('[data-thumb]');
      const slides = gallery.querySelectorAll('[data-media-id]');
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const id = thumb.getAttribute('data-thumb');
          thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
          const target = gallery.querySelector(`[data-media-id="${id}"]`);
          if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });
      const track = gallery.querySelector('[data-gallery-track]');
      if (track && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const id = entry.target.getAttribute('data-media-id');
                thumbs.forEach((t) => t.classList.toggle('is-active', t.getAttribute('data-thumb') === id));
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach((s) => io.observe(s));
      }
      gallery.querySelectorAll('[data-media-id]').forEach((slide) => {
        slide.addEventListener('click', () => {
          const img = slide.querySelector('img');
          if (!img) return;
          const lightbox = document.getElementById('lightbox-modal');
          if (!lightbox) return;
          lightbox.querySelector('img').src = img.getAttribute('src');
          lightbox.querySelector('img').alt = img.alt;
          Veliora.openModal('lightbox-modal');
        });
      });
    });
  }

  /* ---------- Sticky Add to Cart ---------- */
  function initStickyAtc() {
    const bar = document.querySelector('[data-sticky-atc]');
    const trigger = document.querySelector('[data-add-to-cart-btn]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0));
      },
      { threshold: 0 }
    );
    io.observe(trigger);
    bar.addEventListener('click', (e) => {
      if (e.target.closest('[data-sticky-atc-submit]')) {
        const mainForm = document.querySelector('form[data-product-form]');
        if (mainForm) mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.dispatchEvent(new Event('submit', { cancelable: true }));
      }
    });
  }

  /* ---------- Quick view ---------- */
  function buildQuickViewHTML(product) {
    const variant = product.variants[0];
    return `
      <div class="quick-view-grid">
        <div class="quick-view-grid__media">
          ${product.featured_image ? `<img src="${product.featured_image}" alt="${product.title}">` : ''}
        </div>
        <div class="quick-view-grid__info">
          <h3>${product.title}</h3>
          <div class="price" style="margin: 10px 0 18px;">
            <span class="price__sale">${moneyFormat(variant.price)}</span>
            ${variant.compare_at_price > variant.price ? `<span class="price__regular">${moneyFormat(variant.compare_at_price)}</span>` : ''}
          </div>
          <p class="text-muted" style="margin-bottom:20px;">${(product.description || '').replace(/<[^>]*>/g, '').slice(0, 140)}...</p>
          <form data-product-form>
            <input type="hidden" name="id" value="${variant.id}">
            <input type="hidden" name="quantity" value="1">
            <button type="submit" class="btn" data-add-to-cart-btn ${!variant.available ? 'disabled' : ''}>
              <span class="btn-label">${variant.available ? 'Add to Bag' : 'Sold Out'}</span>
              <span class="loading-spinner"></span>
            </button>
          </form>
          <a href="${product.url}" class="btn--text" style="display:inline-block;margin-top:18px;">View Full Details</a>
        </div>
      </div>`;
  }

  function initQuickView() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-quick-view-handle]');
      if (!trigger) return;
      const handle = trigger.getAttribute('data-quick-view-handle');
      const modal = document.getElementById('quick-view-modal');
      const panel = modal.querySelector('.modal-panel');
      panel.innerHTML = '<div style="padding:60px;text-align:center;"><span class="loading-spinner" style="border-color:rgba(0,0,0,.15);border-top-color:#000;"></span></div>';
      Veliora.openModal('quick-view-modal');
      fetch(`/products/${handle}.js`)
        .then((res) => res.json())
        .then((product) => {
          panel.innerHTML = '<button type="button" class="modal-close" data-modal-close aria-label="Close">&times;</button>' + buildQuickViewHTML(product);
        })
        .catch(() => {
          panel.innerHTML = '<p style="padding:40px;">Unable to load product.</p>';
        });
    });
  }

  /* ---------- Ask a question form ---------- */
  function initAskQuestion() {
    const form = document.querySelector('[data-ask-question-form]');
    if (!form) return;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      form.style.display = 'none';
      const success = form.parentElement.querySelector('.form-success');
      if (success) success.style.display = 'block';
    });
  }

  /* ---------- Share link ---------- */
  function initShare() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-share-link]');
      if (!btn) return;
      const url = window.location.href;
      const message = (window.Veliora.strings && window.Veliora.strings.linkCopied) || 'Link copied to clipboard';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => Veliora.toast(message)).catch(() => {});
      } else if (navigator.share) {
        navigator.share({ url }).catch(() => {});
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initVariantPickers();
    initGallery();
    initStickyAtc();
    initQuickView();
    initAskQuestion();
    initShare();
  });
})();
